import { render } from "./eSIMPlans.vue?vue&type=template&id=e2c44148&scoped=true&ts=true"
import script from "./eSIMPlans.vue?vue&type=script&lang=ts"
export * from "./eSIMPlans.vue?vue&type=script&lang=ts"

import "./eSIMPlans.vue?vue&type=style&index=0&id=e2c44148&scoped=true&lang=scss"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2c44148"]])

export default __exports__